/**
 * The social card frame, in one place.
 *
 * Separate from the renderer because both sides need these numbers and only
 * one side can afford the renderer's dependencies. `seo-head.tsx` emits them
 * as `og:image:width`/`height` and runs in the browser; importing them from
 * `card.server.tsx` would pull Satori and Resvg into the client bundle.
 *
 * They must not drift apart. A card that declares 1200x630 in its meta tags
 * and renders at some other size gets letterboxed or cropped by every consumer
 * that trusts the tag, and the tag is trusted precisely because it is usually
 * right.
 *
 * 1200x630 is the Open Graph frame. The source artwork is 1731x909, the same
 * 1.905 ratio, so it fits with no crop.
 */
export const CARD_WIDTH = 1200
export const CARD_HEIGHT = 630
